"use client";

import Banner from "./sections/banner/Banner";
import TopDestinations from "./sections/top-destinations/TopDestinations";
import HotelCarousel from "./sections/hotels/HotelCarousel";
import RentalCarousel from "./sections/rentals/RentalCarousel";
import ActivitieCarousel from "./sections/activities/ActivitieCarousel";
import SpaMassageCarousel from "./sections/spa-msg/SpaMassageCarousel";
import DiscoverCarousel from "./sections/discover/DiscoverCarousel";
import TestimonialCarousel from "./sections/testimonial/TestimonialCarousel";
import { Headset, ShieldCheck, Tag, type LucideIcon } from "lucide-react";
import { mainPadding } from "@/lib/utils";
import { useSocket } from "@/hooks/useSocket";
import { logger } from "@/lib/logger";
import { Typography } from "../Typography";
import { SiteFrame } from "../layout/SiteFrame";

const highlights: [LucideIcon, string, string][] = [
  [Headset, "Local support", "Real people, here for you"],
  [ShieldCheck, "Easy booking", "Fast, secure and simple"],
  [Tag, "Clear pricing", "No hidden fees"],
];

const HomePage = () => {
  const { socket } = useSocket();
  logger.log("[socket] socket:", socket?.id);

  return (
    <div className="space-y-6">
      <section className={mainPadding}>
        <SiteFrame outerClassName="py-4">
          <ul className="mb-6 flex snap-x snap-mandatory gap-6 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:grid sm:grid-cols-3 sm:gap-6 sm:justify-items-center">
            {highlights.map(([Icon, title, subtitle]) => (
              <li
                key={title}
                className="flex shrink-0 snap-start items-center gap-3 sm:justify-self-center"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full !bg-primary-muted">
                  <Icon className="h-5 w-5 text-primary" />
                </span>
                <div>
                  <Typography variant="subtitle1" mdVariant="h6">
                    {title}
                  </Typography>
                  <Typography
                    variant="body1"
                    mdVariant="body2"
                    className="text-body"
                  >
                    {subtitle}
                  </Typography>
                </div>
              </li>
            ))}
          </ul>
        </SiteFrame>

        <Banner />
        <TopDestinations />
        <HotelCarousel
          title="Accommodation / កន្លែងស្នាក់នៅ"
          href="/hotels"
          icon="/services/hotel.svg"
        />
        <RentalCarousel
          title="Rentals / ជួលម៉ូតូ"
          href="/rentals"
          icon="/services/rental.svg"
        />
        <ActivitieCarousel
          title="Tours & Activities / ដំណើរកម្សាន្ត"
          href="/tour-act"
          icon="/services/activity.svg"
        />
        <SpaMassageCarousel
          title="Spas & Massages / ស៉្បានិងម៉ាស្សា"
          href="/spa-msg"
          icon="/services/spa-massage.svg"
        />
      </section>

      <section>
        <TestimonialCarousel />
      </section>

      <section className={mainPadding}>
        <DiscoverCarousel
          title="Discover Cambodia l ដើរលេងស្រុកខ្មែរ"
          href="/discover"
        />
      </section>
    </div>
  );
};

export default HomePage;
